export function isValidDate(input) {
    return Object.prototype.toString.call(input) === "[object Date]" && !isNaN(input);
}